import promotion from '../newcomponents/customerComponents/Promotion';

export const readStoredJSON = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch {
    return null;
  }
};

export const getOrderContact = (order = {}, takeAwayInfo = {}) => {
  const contact = {};
  ['customerName', 'phone', 'address', 'addressLine', 'postal', 'unit', 'scheduleTime', 'remark', 'checkbox', 'roomNo', 'deliveryType'].forEach(key => {
    const value = order[key] !== undefined ? order[key] : takeAwayInfo[key];
    if (value !== undefined) contact[key] = value;
  });
  return contact;
};

// An unhydrated field must not erase a saved value. Explicit clears (null, '',
// [], false and 0) are intentional edits and must still replace the snapshot.
export const mergePendingOrder = (order, changes) => ({
  ...order,
  ...Object.fromEntries(Object.entries(changes).filter(([, value]) => value !== undefined))
});

export const mergeCheckoutPromotions = (fresh = [], state) => {
  const rewardIds = new Set((state.redeem || []).map(reward => reward.rewardId));
  const memberIds = new Set((state.customer?.promotion || []).map(promotion => promotion._id));
  const selected = (state.pm || []).filter(promotion =>
    (promotion.customerRewardId && rewardIds.has(promotion.customerRewardId)) ||
    (promotion.isVoucher && state.vouchers?.length) ||
    (promotion._id && memberIds.has(promotion._id)));
  const selectedIds = new Set(selected.map(promotion => promotion._id).filter(Boolean));
  return [...(fresh || []).filter(promotion => !selectedIds.has(promotion._id)), ...selected]
    .sort((a, b) => (b.eventPriority || 0) - (a.eventPriority || 0));
};

export const savePendingOrder = (order, takeAwayInfo, paymentContext = {}) => {
  const previousContext = readPendingContext();
  localStorage.setItem('order', JSON.stringify(order.data));
  localStorage.setItem('finalOrder', JSON.stringify(order));
  localStorage.setItem('pendingPaymentContext', JSON.stringify({
    ...mergePendingOrder(previousContext?.orderId === order.orderId ? previousContext : {}, paymentContext),
    orderId: order.orderId,
    userId: order.userId,
    orderTime: localStorage.getItem('orderTime'),
    takeAwayInfo: { ...takeAwayInfo, ...getOrderContact(order, takeAwayInfo) }
  }));
};

export const readPendingContext = () => {
  const context = readStoredJSON('pendingPaymentContext');
  const order = readStoredJSON('finalOrder');
  return context && order && context.orderId === order.orderId &&
    String(context.userId) === localStorage.getItem('userId') &&
    context.orderTime === localStorage.getItem('orderTime') ? context : null;
};

export const clearPendingOrder = (orderId) => {
  const order = readStoredJSON('finalOrder');
  // A callback for an older order must not delete a newer checkout.
  if (!order || order.orderId !== orderId) return false;
  localStorage.removeItem('order');
  localStorage.removeItem('finalOrder');
  localStorage.removeItem('pendingPaymentContext');
  localStorage.removeItem('shouldRedirect');
  return true;
};

const isNumber = value => value !== null && value !== '' &&
  typeof value !== 'undefined' && Number.isFinite(Number(value));

export const getCheckoutPricing = (cart, discount, tax, paymentData, isTakeAway, deliveryType) => {
  const excluded = isTakeAway ? paymentData?.shouldExclude : paymentData?.shouldExcludeDI;
  const serviceCharge = excluded ? 0 : Number(paymentData?.serviceCharge);
  const ready = !!tax && isNumber(tax.taxMode) &&
    (Number(tax.taxMode) !== 0 || isNumber(tax.tax)) &&
    !!paymentData && (excluded || isNumber(paymentData.serviceCharge));
  if (!ready) return { ready: false, serviceCharge: 0, finalAmount: 0 };
  const normalizedTax = { ...tax, taxMode: Number(tax.taxMode), tax: Number(tax.tax) };
  const finalAmount = promotion.getFinalAmount(cart, discount, serviceCharge, normalizedTax, paymentData, isTakeAway, deliveryType);
  return { ready: Number.isFinite(finalAmount), serviceCharge, finalAmount };
};
